import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function PrivacyPolicy() {
  const { strings } = useLanguage();
  const isRussian = strings?.lang_code === 'RU';

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2rem',
    alignItems: 'flex-start',
  };

  const columnStyle = {
    flex: '1 1 320px',
    minWidth: '320px',
    padding: '0 1rem',
  };

  const sectionStyle = {
    marginBottom: '1.5rem',
  };

  return (
    <div style={containerStyle}>
      <div style={columnStyle}>
        {isRussian ? (
          <>
            <p style={sectionStyle}>
              Настоящая Политика конфиденциальности объясняет, как Ассоциация русскоязычных специалистов в Швейцарии («Поставщик») собирает, использует, хранит и защищает персональные данные при доступе к веб-сайту или использовании онлайн-психологических услуг.
            </p>

            <h2 style={sectionStyle}>1. Оператор персональных данных</h2>
            <p style={sectionStyle}>
              <strong>Ассоциация русскоязычных специалистов в Швейцарии</strong><br />
              Email: info@rpswiss.ch<br />
              Веб-сайт: https://www.rpswiss.ch
            </p>

            <h2 style={sectionStyle}>2. Категории собираемых персональных данных</h2>
            <p style={sectionStyle}>Поставщик может собирать и обрабатывать следующие категории персональных данных:</p>
            <ul style={sectionStyle}>
              <li>Идентификационные данные (имя, дата рождения)</li>
              <li>Контактные данные (адрес электронной почты, номер телефона)</li>
              <li>Платежная информация и данные выставления счетов</li>
              <li>Технические данные (IP-адрес, тип браузера, информация об устройстве)</li>
              <li>Информация, переданная во время консультаций или через формы приема</li>
              <li>Записи коммуникаций</li>
            </ul>

            <h2 style={sectionStyle}>3. Цели обработки</h2>
            <p style={sectionStyle}>Персональные данные обрабатываются в следующих целях:</p>
            <ul style={sectionStyle}>
              <li>Предоставление информации о соответствующих продуктах и услугах</li>
              <li>Выставление счетов и обработка платежей</li>
              <li>Соблюдение юридических и профессиональных обязательств</li>
              <li>Функциональность и безопасность веб-сайта</li>
              <li>Связь с клиентами</li>
            </ul>

            <h2 style={sectionStyle}>4. Правовые основания для обработки</h2>
            <p style={sectionStyle}>Обработка основана на одном или нескольких из следующих правовых оснований:</p>
            <p style={sectionStyle}>
              • Исполнение договора<br />
              • Согласие<br />
              • Соблюдение юридических обязательств<br />
              • Законные профессиональные интересы, где это применимо
            </p>

            <h2 style={sectionStyle}>5. Конфиденциальные данные</h2>
            <p style={sectionStyle}>
              Такие данные обрабатываются конфиденциально и в соответствии с применимыми обязательствами по защите данных и профессиональной тайне.
            </p>

            <h2 style={sectionStyle}>6. Передача данных</h2>
            <p style={sectionStyle}>Персональные данные могут передаваться только по мере необходимости:</p>
            <p style={sectionStyle}>
              • Платежным системам<br />
              • Провайдерам ИТ-услуг и хостинга<br />
              • Профессиональным консультантам или супервизорам (при необходимости и в анонимизированном виде, где возможно)<br />
              • Органам власти, когда это требуется по закону
            </p>
            <p style={sectionStyle}>Поставщик не продает персональные данные.</p>

            <h2 style={sectionStyle}>7. Международная передача данных</h2>
            <p style={sectionStyle}>
              В случае трансграничной передачи персональных данных будут внедрены надлежащие меры защиты в соответствии с применимыми законами о защите данных.
            </p>

            <h2 style={sectionStyle}>8. Хранение данных</h2>
            <p style={sectionStyle}>
              Персональные данные хранятся только до тех пор, пока это необходимо для целей, описанных выше, включая соблюдение юридических, нормативных и профессиональных обязательств по ведению учета.
            </p>
          </>
        ) : (
          <>
            <p style={sectionStyle}>
              This Privacy Policy explains how The Association of Russian Speaking Professionals in Switzerland (“Provider”) collects, uses, stores, and protects personal data when you access the website or use online psychological services.
            </p>

            <h2 style={sectionStyle}>1. Data Controller</h2>
            <p style={sectionStyle}>
              <strong>The Association of Russian Speaking Professionals in Switzerland</strong><br />
              Email: info@rpswiss.ch<br />
              Website: https://www.rpswiss.ch
            </p>

            <h2 style={sectionStyle}>2. Categories of Personal Data Collected</h2>
            <p style={sectionStyle}>The Provider may collect and process the following categories of personal data:</p>
            <ul style={sectionStyle}>
              <li>Identification data (name, date of birth)</li>
              <li>Contact details (email address, telephone number)</li>
              <li>Billing and payment information</li>
              <li>Technical data (IP address, browser type, device information)</li>
              <li>Information shared during consultations or via intake forms</li>
              <li>Communication records</li>
            </ul>

            <h2 style={sectionStyle}>3. Purpose of Processing</h2>
            <p style={sectionStyle}>Personal data is processed for the following purposes:</p>
            <ul style={sectionStyle}>
              <li>Providing information regarding relevant products and services</li>
              <li>Billing and payment processing</li>
              <li>Compliance with legal and professional obligations</li>
              <li>Website functionality and security</li>
              <li>Communication with clients</li>
            </ul>

            <h2 style={sectionStyle}>4. Legal Basis for Processing</h2>
            <p style={sectionStyle}>Processing is based on one or more of the following legal grounds:</p>
            <p style={sectionStyle}>
              • Performance of a contract<br />
              • Consent<br />
              • Compliance with legal obligations<br />
              • Legitimate professional interests, where applicable
            </p>

            <h2 style={sectionStyle}>5. Sensitive Data</h2>
            <p style={sectionStyle}>
              Such data is processed confidentially and in accordance with applicable data protection and professional confidentiality obligations.
            </p>

            <h2 style={sectionStyle}>6. Data Sharing</h2>
            <p style={sectionStyle}>Personal data may be shared only where necessary with:</p>
            <p style={sectionStyle}>
              • Payment processors<br />
              • IT and hosting service providers<br />
              • Professional advisors or supervisors (where appropriate and anonymized where possible)<br />
              • Authorities where required by law
            </p>
            <p style={sectionStyle}>The Provider does not sell personal data.</p>

            <h2 style={sectionStyle}>7. International Data Transfers</h2>
            <p style={sectionStyle}>
              If personal data is transferred across borders, appropriate safeguards will be implemented in accordance with applicable data protection laws.
            </p>

            <h2 style={sectionStyle}>8. Data Retention</h2>
            <p style={sectionStyle}>
              Personal data is retained only as long as necessary for the purposes described above, including compliance with legal, regulatory, and professional record-keeping obligations.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

